import React, { memo } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import TooltipedSortLabel, { SORT_LABEL_ALIGNMENT } from '@sharedCR/common/TooltipedSortLabel';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { TABLE_CELL_ALIGNMENT } from 'constants/ui';

import { ProgramsAndPricingTestIds } from '../../ProgramsAndPricing.testIds';
import { ColumnDefShape } from '../../ProgramsAndPricing.types';

import {
  getHeadCellStyles,
  headCellsWrapperStyles,
  labelStyles,
  programsTableHeadStyles,
} from './ProgramsTableHead.styles';

const ProgramsTableHead = ({ onRequestSort, order, columnsDefs }) => (
  <Stack sx={programsTableHeadStyles}>
    <Box className="w-40" data-testid={ProgramsAndPricingTestIds.COLUMN_STUB} />
    <Stack sx={headCellsWrapperStyles}>
      {columnsDefs.map(({ id, label, style, align, isSort = true }) => (
        <Box
          align={!isSort ? align : TABLE_CELL_ALIGNMENT.INHERIT}
          key={id}
          sx={getHeadCellStyles(style)}
        >
          <TooltipedSortLabel
            align={SORT_LABEL_ALIGNMENT[_.upperCase(align)]}
            id={id}
            isSort={isSort}
            label={
              <Typography
                className="truncate"
                component="span"
                sx={labelStyles}
                variant="regular14"
              >
                {label}
              </Typography>
            }
            order={order}
            onRequestSort={onRequestSort}
          />
        </Box>
      ))}
    </Stack>
    <Box className="w-24" data-testid={ProgramsAndPricingTestIds.COLUMN_STUB} />
  </Stack>
);

ProgramsTableHead.propTypes = {
  columnsDefs: PropTypes.arrayOf(ColumnDefShape).isRequired,
  order: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
};

export default memo(ProgramsTableHead);
